import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Button from 'flarum/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import Link from 'flarum/common/components/Link';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import FloatPostButton from '../../common/components/FloatPostButton';
import NavigationBar from './NavigationBar';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
import LogInModal from 'flarum/forum/components/LogInModal';

//主页
export default class WiKiPage extends Page {
  lastDiscussion;
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    this.tags = [];
    this.tagItem = [];
    this.localeName = '';
    this.localeMainImgUrl = '';
    this.wikiData = [];
    this.activeTab = 1; // 默认激活的 tab
    this.heroSearchQuery = ''; // 英雄搜索关键词
    this.heroSearchResults = []; // 英雄搜索结果
    this.heroAttribute = 0; // 英雄属性
    this.isSearch = false; // 是否是英雄搜索
    if (app.previous.matches(DiscussionPage)) {
      this.lastDiscussion = app.previous.get('discussion');
    }
    app.tagList
      .load([
        'children',
        'lastPostedDiscussion',
        'parent',
        'wikiLabel',
        'wikiLabel.wikiLabelOptions',
        'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon', 'heroTagLatestdata' ,'heroTagLatestdata.heroTagHeroIntro' ,'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel'
      ])
      .then(() => {
        this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));
        const pinned = this.tags.filter((tag) => tag.position() !== null);
        this.tagItem = pinned.filter((tag) => {
          return this.attrs.tags === tag.slug();
        });
        if (this.tagItem.length > 0) {
          let name = this.tagItem[0]?.name();
          if (name) {
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(name);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            // 获取特定键的值
            this.localeName = map.get(app.data.locale);
            app.setTitle(this.localeName);
          }
          let mainImgUrl = this.tagItem[0]?.mainImgUrl();
          this.wikiData = this.tagItem[0].wikiLabel();
  
          if (mainImgUrl) {
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(mainImgUrl);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            let objPc = app.store.models.type != 'phone' ? map.get('pc') : map.get('phone');
            // 获取特定键的值
            this.localeMainImgUrl = objPc[app.data.locale];
          }
        }
        this.loading = false;
        m.redraw();
      });

    sessionStorage.setItem('tagItem', this.attrs.tags);
    app.discussions.refreshParams(app.search.params(), (m.route.param('page') && Number(m.route.param('page'))) || 1);
    app.history.push(`t/${this.attrs.tags}`, app.translator.trans('flarum-tags.forum.header.back_to_tags_tooltip'));
    if (!app.cache.heroHeight) {
      app.cache.heroHeight = {};
    }
    if (!app.cache.scrollTop) {
      app.cache.scrollTop = {};
    }
    if (!app.cache.activeTab) {
      app.cache.activeTab = 1;
    }
  }
  oncreate(vnode) {
    super.oncreate(vnode);

    // Work out the difference between the height of this hero and that of the
    // previous hero. Maintain the same scroll position relative to the bottom
    // of the hero so that the sidebar doesn't jump around.
    const oldHeroHeight = app.cache.heroHeight['WiKiPage'];
    const heroHeight = (app.cache.heroHeight['WiKiPage'] = this.$('.Hero').outerHeight() || 0);
    const scrollTop = app.cache.scrollTop[`WiKiPage${this.attrs.tags}`];
    $('#app').css('min-height', ($(window).height() || 0) + scrollTop);

    // Let browser handle scrolling on page reload.
    if (app.previous.type == null) return;
    this.activeTab = app.cache.activeTab;

    // Only retain scroll position if we're coming from a discussion page.
    // Otherwise, we've just changed the filter, so we should go to the top of the page.
    if (this.lastDiscussion || scrollTop) {
      $(window).scrollTop(scrollTop - oldHeroHeight);
    } else {
      $(window).scrollTop(0);
    }
    if (this.lastDiscussion) {
      const $discussion = this.$(`li[data-id="${this.lastDiscussion.id()}"] .DiscussionListItem`);

      if ($discussion.length) {
        const indexTop = $('#app-navigation').outerHeight() || 0;

        const indexBottom = $(window).height() || 0;
        const discussionOffset = $discussion.offset();
        const discussionTop = (discussionOffset && discussionOffset.top) || 0;
        const discussionBottom = discussionTop + ($discussion.outerHeight() || 0);

        if (discussionTop < scrollTop + indexTop || discussionBottom > scrollTop + indexBottom) {
          $(window).scrollTop(discussionTop - indexTop);
        }
      }
    }
  }

  onbeforeremove(vnode) {
    super.onbeforeremove(vnode);

    // Save the scroll position so we can restore it when we return to the
    // discussion list.
    app.cache.scrollTop[`WiKiPage${this.attrs.tags}`] = $(window).scrollTop();
  }
  onremove(vnode) {
    super.onremove(vnode);

    $('#app').css('min-height', '');
  }

  // 切换 tab 的方法
  switchTab(tabName) {
    this.activeTab = tabName;
    app.cache.activeTab = tabName;
    m.redraw();
  }

  // 英雄搜索输入处理
  onHeroSearchInput(e) {
    this.heroSearchQuery = e.target.value;
    if (!this.heroSearchQuery.trim()) {
      this.heroSearchResults = [];
      this.isSearch = false;
    }
    m.redraw();
  }

  // 英雄搜索键盘事件处理
  onHeroSearchKeydown(e) {
    if (e.key === 'Enter') {
      this.performHeroSearch();
    }
  }

  // 执行英雄搜索
  performHeroSearch() {
    if (!this.heroSearchQuery.trim()) {
      this.heroSearchResults = [];
      this.isSearch = false;
      m.redraw();
      return;
    }
    // 调用真实的API接口
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/selectWikiHero',
        params: {
          name: this.heroSearchQuery.trim(),
          labelId: this.wikiData[this.activeTab - 1].wikiLabelOptions()[0].labelId(),
        },
      })
      .then((response) => {
        this.heroSearchResults = response || [];
      })
      .catch((error) => {
        this.heroSearchResults = [];
        console.error('英雄搜索失败:', error);
      })
      .finally(() => {
        this.isSearch = true;
        m.redraw();
      });
  }

  // 英雄属性点击处理
  onHeroAttributeClick(item) {
    this.heroAttribute = item;
    m.redraw();
  }

  // 渲染 tab 内容
  renderTabContent() {
    if (this.wikiData.length === 0) {
      return <div className="tab-panel">{app.translator.trans('dl-wiki.forum.loading')}</div>;
    }
    let wikiLabelOptions = this.wikiData[0].wikiLabelOptions();
    wikiLabelOptions = wikiLabelOptions.filter((item) => item.status() == 1);
    wikiLabelOptions = wikiLabelOptions.sort((a, b) => a.sortCount() - b.sortCount());

    let wikiHeroOptions = this.wikiData[1].wikiLabelOptions();
    wikiHeroOptions = wikiHeroOptions.filter((item) => item.status() == 1);
    wikiHeroOptions = wikiHeroOptions.sort((a, b) => a.sortCount() - b.sortCount());
    let attributeList = wikiHeroOptions.map((item) => {
      return this.multilingual(item.icon());
    });;
    let wikiWorldOptions = this.wikiData[2].wikiLabelOptions();
    wikiWorldOptions = wikiWorldOptions.filter((item) => item.status() == 1);
    wikiWorldOptions = wikiWorldOptions.sort((a, b) => a.sortCount() - b.sortCount());

    if (this.isSearch) {
      wikiHeroOptions = this.heroSearchResults
        .filter((item) => item && item.sons.length > 0 && item.status == 1)
        .sort((a, b) => a.sortCount - b.sortCount);
    }
    if (this.heroAttribute > 0) {
      wikiHeroOptions = wikiHeroOptions[this.heroAttribute - 1] ? [wikiHeroOptions[this.heroAttribute - 1]] : [];
    }      
    return (
      <>
        <div className={`tab-panel world-panel ${this.activeTab === 1 ? 'show' : ''}`}>
          {wikiLabelOptions.map((item) => {
            return (
              item.status() && (
                <div className="world-content">
                  <div className="world-content-title">
                    <span>{this.multilingual(item.name())}</span>
                  </div>
                  <div className="world-content-content">
                    {item
                      .wikiLabelOptionsSon()
                      .filter((item2) => item2.status() == 1)
                      .sort((a, b) => a.sortCount() - b.sortCount())
                      .map((item2) => {
                        return (
                          <Link href={`${app.forum.attribute('baseUrl')}${item2.link()}`} className="world-content-content-item">
                            <div className="item-bg">
                              <img src={this.multilingual(item2.subIcon())} />
                            </div>
                            <div className="item-img">
                              <img src={this.multilingual(item2.icon())} />
                            </div>
                            <div className="item-content">
                              <div className="item-content-title">
                                <span>{this.multilingual(item2.name())}</span>
                              </div>
                              <div className="item-content-desc">
                                <span>{this.multilingual(item2.subName())}</span>
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                </div>
              )
            );
          })}
        </div>
        <div className={`tab-panel hero-panel ${this.activeTab === 2 ? 'show' : ''}`}>
          <div className="hero-search-box">
            <div className="hero-attribute">
              <span>{app.translator.trans('dl-wiki.forum.property')}</span>
              <div className="hero-attribute-content">
                <div
                  className={`hero-attribute-content-item ${this.heroAttribute === 0 ? 'active' : ''}`}
                  onclick={() => this.onHeroAttributeClick(0)}
                >
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/wiki-icon0.png`} />
                </div>
                {attributeList.map((item, index) => {
                  return (
                    <div
                      className={`hero-attribute-content-item ${this.heroAttribute === index + 1 ? 'active' : ''}`}
                      onclick={() => this.onHeroAttributeClick(index + 1)}
                    >
                      <img src={item} />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="hero-search-input">
              <div className="search-input-wrapper">
                <input
                  type="search"
                  className="search-input"
                  placeholder={app.translator.trans('dl-wiki.forum.search')}
                  value={this.heroSearchQuery || ''}
                  oninput={(e) => this.onHeroSearchInput(e)}
                  onkeydown={(e) => this.onHeroSearchKeydown(e)}
                />
                {this.heroSearchQuery && this.heroSearchQuery.length > 0 && (
                  <span className="clear-btn" onclick={() => this.clearInput()}>
                    <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-qingkong.png`} />
                  </span>
                )}
                <button className="search-btn" onclick={() => this.performHeroSearch()}>
                  <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-sousuohs.png`} />
                </button>
              </div>
            </div>
          </div>
          {wikiHeroOptions.map((item) => {
            return (
              <div className="hero-content">
                <div className="hero-content-icon">
                  <img src={this.isSearch ? this.multilingual(item.subIcon) : this.multilingual(item.subIcon())} />
                </div>
                <div className="hero-content-title">
                  <img src={this.isSearch ? this.multilingual(item.icon) : this.multilingual(item.icon())} />
                  <span>{this.isSearch ? this.multilingual(item.name) : this.multilingual(item.name())}</span>
                </div>
                <div className="hero-content-content">
                  {this.isSearch
                    ? item.sons
                        .filter((item2) => item2.status == 1)
                        .sort((a, b) => a.sortCount - b.sortCount)
                        .map((item2) => {
                          return (
                            <Link href={`${app.forum.attribute('baseUrl')}/${item2.link}`} className="hero-content-content-item">
                              <div className="item-img">
                                <img src={this.multilingual(item2.icon)} />
                              </div>
                              <div className="item-content">
                                <span>{this.multilingual(item2.name)}</span>
                              </div>
                            </Link>
                          );
                        })
                    : item
                        .wikiLabelOptionsSon()
                        .filter((item2) => item2.status() == 1)
                        .sort((a, b) => a.sortCount() - b.sortCount())
                        .map((item2) => {
                          return (
                            <Link href={`${app.forum.attribute('baseUrl')}${item2.link()}`} className="hero-content-content-item">
                              <div className="item-img">
                                <img src={this.multilingual(item2.icon())} />
                              </div>
                              <div className="item-content">
                                <span>{this.multilingual(item2.name())}</span>
                              </div>
                            </Link>
                          );
                        })}
                </div>
              </div>
            );
          })}
        </div>
        <div className={`tab-panel world-panel ${this.activeTab === 3 ? 'show' : ''}`}>
          {wikiWorldOptions.map((item) => {
            return (
              item.status() && (
                <div className="world-content">
                  <div className="world-content-title">
                    <span>{this.multilingual(item.name())}</span>
                  </div>
                  <div className="world-content-content">
                    {item
                      .wikiLabelOptionsSon()
                      .filter((item2) => item2.status() == 1)
                      .sort((a, b) => a.sortCount() - b.sortCount())
                      .map((item2) => {
                        return (
                          <Link href={`${app.forum.attribute('baseUrl')}${item2.link()}`} className="world-content-content-item">
                            <div className="item-bg">
                              <img src={this.multilingual(item2.subIcon())} />
                            </div>
                            <div className="item-img">
                              <img src={this.multilingual(item2.icon())} />
                            </div>
                            <div className="item-content">
                              <div className="item-content-title">
                                <span>{this.multilingual(item2.name())}</span>
                              </div>
                              <div className="item-content-desc">
                                <span>{this.multilingual(item2.subName())}</span>
                              </div>
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                </div>
              )
            );
          })}
        </div>
      </>
    );
  }
  multilingual(name) {
    if (!name) return '';
    let data = JSON.parse(name);
    return data[app.data.locale];
  }
  clearInput() {
    this.heroSearchQuery = '';
    this.heroSearchResults = [];
    this.isSearch = false;
    m.redraw();
  }

  title() {
    return <h4 className="App-titleControl tagTitle">{listItems(this.items().toArray())}</h4>;
  }

  items() {
    const items = new ItemList();
    if (this.loading) {
      items.add('loading', <LoadingIndicator />);
    } else {
      const pinned = this.tags.filter((tag) => tag.position() !== null);
      this.tagItem = pinned.filter((tag) => {
        return this.attrs.tags === tag.slug();
      });
      if (pinned) {
        if (app.store.models.type != 'phone') {
          items.add(
            'title',
            <div className="dl-header-tabs">
              <NavigationBar />
            </div>
          );
        } else {
          items.add('title', <div className="dl-header-tabs">{PagePage.prototype.headerTabs(this)}</div>);
        }
      }

      if (this.tagItem.length > 0) {
        let name = this.tagItem[0]?.name();
        if (name) {
          // 将字符串映射转换为 JavaScript 对象
          const obj = JSON.parse(name);
          // 创建 Map 对象并初始化
          const map = new Map(Object.entries(obj));
          // 获取特定键的值
          this.localeName = map.get(app.data.locale);
          app.setTitle(this.localeName);
        }
        let mainImgUrl = this.tagItem[0]?.mainImgUrl();
        this.wikiData = this.tagItem[0].wikiLabel();

        if (mainImgUrl) {
          // 将字符串映射转换为 JavaScript 对象
          const obj = JSON.parse(mainImgUrl);
          // 创建 Map 对象并初始化
          const map = new Map(Object.entries(obj));
          let objPc = app.store.models.type != 'phone' ? map.get('pc') : map.get('phone');
          // 获取特定键的值
          this.localeMainImgUrl = objPc[app.data.locale];
        }
      }
    }

    return items;
  }

  view() {
    let url = app.forum.attribute('baseUrl');
    // console.log("wikiLabel().wikiLabelOptions().wikiLabelOptionsSon()",this.tagItem[0])

    // const centerOnClick = (event) => {
    //   if (!app.session.user) {
    //     event.preventDefault();
    //     app.modal.show(LogInModal);
    //     return;
    //   }
    // };
    return (
      <main class="App-content">
        {app.store.models.type == 'phone' && this.title()}
        <div id="content">
          <div className="WiKiPage">
            <div className="WikiPage-header">
              {this.localeMainImgUrl ? <img className="image-placeholder" src={this.localeMainImgUrl} alt={this.localeName} /> : <></>}
            </div>
            <div className="WikiPage-content-box">
              <div className="WikiPage-content">
                <div className="wiki-tabs">
                  <div className="wiki-tab-header">
                    {this.wikiData
                      .filter((item) => item.status() == 1)
                      .map((item) => {
                        return (
                          <button
                            className={`wiki-tab-btn ${this.activeTab === item.sortCount() ? 'active' : ''}`}
                            onclick={() => this.switchTab(item.sortCount())}
                          >
                            <img src={this.multilingual(item.icon())} />
                            <span>{this.multilingual(item.name())}</span>
                          </button>
                        );
                      })}
                  </div>
                  <div className="wiki-tab-content">{this.renderTabContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
